import { createSelector } from 'reselect';

import {
  selectEntitiesAchievementsEntityEligibilityNbBetsToPlace,
  selectEntitiesAchievementsEntityEligibilityNbBetsToWin,
} from '../../../../selectors/entities/achievements/entitiesAchievementsPrimary.selector';
import { Selector } from '../../../../types/selectors';
import { selectAchievementNbBetsToTry } from '../../selectors/achievements';
import { selectUserMissionAchievements } from '../../selectors/userMissionAchievements';
import { getAchievementIdFromProps } from '../../selectors/utils';
import { UserAchievementStatuses, UserBetslipState } from '../../types/state/userMissions';

export const getNbValidatedBetsFromAchievement = (
  userMissionAchievementBetslips: {
    [betslipReference: string]: UserBetslipState;
  },
  nbBetsToWin?: number | null,
  nbBetsToPlace?: number | null,
): number | undefined => {
  if (nbBetsToWin) {
    return Object.keys(userMissionAchievementBetslips).filter(
      (betslipId) => userMissionAchievementBetslips[betslipId].achievementStatus === UserAchievementStatuses.WON,
    ).length;
  }
  if (nbBetsToPlace) {
    return Object.keys(userMissionAchievementBetslips).filter(
      (betslipId) => userMissionAchievementBetslips[betslipId].achievementStatus !== UserAchievementStatuses.CANCELLED,
    ).length;
  }
};

const selectUserMissionAchievementNbValidatedBets: Selector<number | undefined> = createSelector(
  [
    selectUserMissionAchievements,
    selectEntitiesAchievementsEntityEligibilityNbBetsToWin,
    selectEntitiesAchievementsEntityEligibilityNbBetsToPlace,
    getAchievementIdFromProps,
  ],
  (userMissionAchievements, nbBetsToWin, nbBetsToPlace, achievementId) => {
    const betslips = userMissionAchievements.find((k) => k?.achievementId === achievementId)?.betslips ?? {};

    return getNbValidatedBetsFromAchievement(betslips, nbBetsToWin, nbBetsToPlace);
  },
);

type MissionDetailsAchievementProgressContainerPropsType = {
  nbSteps?: number;
  nbCompleted?: number;
};

const selectMissionDetailsAchievementProgressContainerProps: Selector<MissionDetailsAchievementProgressContainerPropsType> =
  createSelector(
    [selectAchievementNbBetsToTry, selectUserMissionAchievementNbValidatedBets],
    (nbSteps, nbCompleted) => ({
      nbSteps: nbSteps ?? 0,
      nbCompleted,
    }),
  );

export default selectMissionDetailsAchievementProgressContainerProps;
